import { render, staticRenderFns } from "./EstablishmentViewTransfers.vue?vue&type=template&id=361f35da"
import script from "./EstablishmentViewTransfers.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports